import React from "react";
import { fetchAttachmentURL } from "../../API/api";
import styles from "./AttachmentBoxStyles.module.css";
import {ReactComponent as VideoIcon} from '../../Icons/videoDark.svg';
import {ReactComponent as ImageIcon} from '../../Icons/imageDark.svg';
import {ReactComponent as DownloadIcon} from '../../Icons/download.svg';
import {ReactComponent as PdfIcon} from '../../Icons/pdfDark.svg';

export default function AttachmentBox({ attachment }) {
  const downloadAttachment = (file) => {
    let payload = {
      name: file,
    };
    if(attachment.name?.includes(".docx") || attachment.name?.includes(".doc") || attachment.name?.includes(".xlsx") || attachment.name.includes(".csv")){
      fetchAttachmentURL(payload)
      .then((res) => {
        if (res===undefined) return;
        var response = res.data.data;
            var aTag = document.createElement("a");
            aTag.setAttribute("href", response.objectUrl);
            aTag.setAttribute("download", response.name);
            aTag.click();
      })
      .catch((err) => {});
    }
    else{
    fetchAttachmentURL(payload)
      .then((res) => {
        if (res===undefined) return;
        var response = res.data.data;
        fetch(response.src).then(function (res1) {
          res1.blob().then(function (blob) {
            var aTag = document.createElement("a");
            aTag.setAttribute("href", URL.createObjectURL(blob));
            aTag.setAttribute("download", response.name);
            aTag.click();
          });
        });
      })
      .catch((err) => {});
    }
  };

  const openPreviewAttachment = (file) => {
    let payload = {
      name: file,
    };
    fetchAttachmentURL(payload)
      .then((res) => {
        if (res===undefined) return;
        var response = res.data.data;
        if ((file?.includes(".pdf") ||file?.includes(".PDF") || file?.includes(".Pdf")) && !file?.includes(".pdf_")) {
          response.src = response.src.replace(
            "data:null",
            "data:application/pdf"
          );
        } else {
          response.src = response.src.replace("data:null", "data:image/png");
        }
        fetch(response.src).then(function (res1) {
          res1.blob().then(function (blob) {
            window.open(URL.createObjectURL(blob), "_blank");
          });
        });
      })
      .catch((err) => {});
  };
  const trimString = (str) => {
    if (str.length > 50) {
      return str.slice(0, 50) + "...";
    }
    return str;
  };
  return (
    <>
      {(attachment?.name?.includes(".pdf") ||attachment?.name?.includes(".PDF") || attachment?.name?.includes(".Pdf")) && !attachment?.name?.includes(".pdf_") ? (
        <span className={styles.imageAttachmentContent}>
          <a onClick={() => openPreviewAttachment(attachment.name)}>
            <PdfIcon/>
            &nbsp;
            {trimString(attachment.name)}
          </a>
          &nbsp;&nbsp;
          <a>
            <span
              onClick={() => downloadAttachment(attachment?.name)}
            >
              <DownloadIcon/>
            </span>
          </a>
        </span>
      ) : null}
      {attachment.name?.includes(".jpeg") ||
      attachment.name?.includes(".jpg") ||
      attachment.name?.includes(".png") ||
      attachment.name?.includes(".JPEG") ||
      attachment.name?.includes(".JPG") ||
      attachment.name?.includes(".PNG") 
      ? (
        <span className={styles.imageAttachmentContent}>
          <a onClick={() => openPreviewAttachment(attachment.name)}>
            <ImageIcon/>&nbsp;
            {attachment.name}
          </a>
          &nbsp;&nbsp;
          <a>
            <span
              // className={styles.downloadIcon}
              onClick={() => downloadAttachment(attachment.name)}
            >
            <DownloadIcon/>
            </span>
          </a>
        </span>
      ) : null}
      {attachment.name?.includes(".mp4") || attachment.name?.includes(".MP4")|| attachment.name?.includes(".mov") ||attachment.name?.includes(".MOV") ? (
        <span className={styles.imageAttachmentContent}>
          <a style={{ pointerEvents: "none" }}>
            <VideoIcon />&nbsp;
            {attachment.name}
          </a>
        </span>
      ) : null}
      {attachment.name?.includes(".docx") || attachment.name?.includes(".doc") || attachment.name?.includes(".xlsx") || attachment.name?.includes(".ppt") || attachment.name.includes('.csv') ? (
        <span className={styles.imageAttachmentContent}>
          <a style={{ pointerEvents: "none" }}>
          <PdfIcon/>
          &nbsp;
            {attachment.name}
          </a>
          &nbsp;&nbsp;
          <a>
            <span
              onClick={() => downloadAttachment(attachment.name)}
            >
              <DownloadIcon/>
            </span>
          </a>
        </span>
      ) : null}
    </>
  );
}
